import { render, staticRenderFns } from "./CardSmall.vue?vue&type=template&id=11415160&scoped=true"
import script from "./CardSmall.vue?vue&type=script&lang=js"
export * from "./CardSmall.vue?vue&type=script&lang=js"
import style0 from "./CardSmall.vue?vue&type=style&index=0&id=11415160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11415160",
  null
  
)

export default component.exports